import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import bt from "../../assets/BusinessTaxes.png";
import services from "../../assets/individualTaxesServices.png";
import atf from "../../assets/AdvanceTaxFiling.png";

export default function BusinessTaxFiling() {
    useEffect(() => {
        AOS.init({ once: true, duration: 850, easing: "ease-in-out" });
    }, []);

    return (
        <div style={{ minHeight: "100vh", background: "#fff" }}>
            <div style={{ height: 72 }} /> {/* Header spacing */}

            {/* Hero Heading */}
            <section className="container py-5">
                <div className="row align-items-center" data-aos="fade-down">
                    <div className="col-lg-8">
                        <h1 className="fw-bold mb-3" style={{ 
                            fontFamily: "Poppins, sans-serif", 
                            color: "#6B46C1",
                            fontSize: "2.5rem"
                        }}>
                            Business Tax Filing
                        </h1>
                        <div className="fs-5 text-secondary mb-4" style={{ lineHeight: "1.8" }}>
                            As a business owner, understanding your tax obligations is crucial to maintaining financial health and staying compliant. 
                            Our expert team helps you navigate complex business tax requirements, maximize deductions, and ensure timely, accurate filing.
                        </div>
                    </div>
                    <div className="col-lg-4 text-center d-none d-lg-block" data-aos="zoom-in">
                        <img
                            src={bt}
                            alt="Business Tax Filing"
                            className="rounded-4 shadow-lg"
                            style={{ width: "100%", maxWidth: "400px" }}
                        />
                    </div>
                </div>
            </section>

            {/* Business Taxes Overview */}
            <section className="container py-5" data-aos="fade-right">
                <div className="row my-5 align-items-center">
                    <div className="col-lg-6 order-lg-1 order-2">
                        <h2 className="fw-bold mb-4" style={{ 
                            color: "#6B46C1", 
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "2rem"
                        }}>
                            Business Taxes Overview
                        </h2>
                        <p className="fs-5 mb-4 text-secondary" style={{ lineHeight: "1.8" }}>
                            Business taxes encompass various types of taxes, including income, payroll, and sales tax. 
                            The type of business entity (LLC, Corporation, Sole Proprietorship, Partnership, S-Corp) determines how taxes are applied and what forms you need to file.
                        </p>
                        <div className="card border-0 shadow-sm mb-4" style={{
                            background: "linear-gradient(135deg, #f7f8ff 0%, #f8e0f5 100%)",
                            borderRadius: "1rem"
                        }}>
                            <div className="card-body p-4">
                                <h5 className="fw-bold mb-3" style={{ color: "#D53F8C" }}>
                                    Why Professional Business Tax Filing Matters
                                </h5>
                                <ul className="mb-0" style={{ lineHeight: "1.8" }}>
                                    <li className="mb-2">
                                        <b style={{ color: "#344476" }}>Compliance:</b> Avoid penalties, interest, and audits by ensuring accurate, timely filing
                                    </li>
                                    <li className="mb-2">
                                        <b style={{ color: "#344476" }}>Maximize Deductions:</b> Identify all eligible business expenses and deductions
                                    </li>
                                    <li>
                                        <b style={{ color: "#344476" }}>Strategic Planning:</b> Optimize your tax strategy for long-term business growth
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 order-lg-2 order-1 mb-4 mb-lg-0 text-center" data-aos="zoom-in">
                        <img
                            src={bt}
                            alt="Business Taxes"
                            className="rounded-4 shadow-lg"
                            style={{ width: "100%", maxWidth: "500px" }}
                        />
                    </div>
                </div>
            </section>

            {/* Types of Business Taxes */}
            <section className="container py-5" data-aos="fade-up">
                <div className="text-center mb-5">
                    <h2 className="fw-bold mb-3" style={{ 
                        color: "#6B46C1", 
                        fontFamily: "Poppins, sans-serif",
                        fontSize: "2rem"
                    }}>
                        Types of Business Taxes
                    </h2>
                </div>
                <div className="row g-4">
                    <div className="col-md-6 col-lg-4">
                        <div className="card border-0 shadow-sm h-100" style={{
                            background: "linear-gradient(135deg, #edeaff 0%, #fff5fb 100%)",
                            borderRadius: "1rem",
                            transition: "transform 0.3s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <i className="bi bi-cash-stack fs-1 me-3" style={{ color: "#6B46C1" }}></i>
                                    <h5 className="fw-bold mb-0" style={{ color: "#6B46C1" }}>
                                        Income Taxes
                                    </h5>
                                </div>
                                <p className="text-secondary mb-0" style={{ lineHeight: "1.7" }}>
                                    Businesses are required to pay taxes on their net income. The type of business entity (LLC, Corporation, Sole Proprietorship, Partnership, S-Corp) determines how taxes are applied and which forms you file.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="card border-0 shadow-sm h-100" style={{
                            background: "linear-gradient(135deg, #fff5fb 0%, #edeaff 100%)",
                            borderRadius: "1rem",
                            transition: "transform 0.3s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <i className="bi bi-person-badge fs-1 me-3" style={{ color: "#6B46C1" }}></i>
                                    <h5 className="fw-bold mb-0" style={{ color: "#6B46C1" }}>
                                        Self-Employment Taxes
                                    </h5>
                                </div>
                                <p className="text-secondary mb-0" style={{ lineHeight: "1.7" }}>
                                    If you're self-employed, you're responsible for both the employer and employee portions of Social Security and Medicare taxes (15.3% total).
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="card border-0 shadow-sm h-100" style={{
                            background: "linear-gradient(135deg, #edeaff 0%, #fff5fb 100%)",
                            borderRadius: "1rem",
                            transition: "transform 0.3s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <i className="bi bi-cart-check fs-1 me-3" style={{ color: "#6B46C1" }}></i>
                                    <h5 className="fw-bold mb-0" style={{ color: "#6B46C1" }}>
                                        Sales Tax
                                    </h5>
                                </div>
                                <p className="text-secondary mb-0" style={{ lineHeight: "1.7" }}>
                                    If your business sells products or services, you must collect and remit sales tax to state authorities based on the tax rate in your location and where you conduct business.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="card border-0 shadow-sm h-100" style={{
                            background: "linear-gradient(135deg, #fff5fb 0%, #edeaff 100%)",
                            borderRadius: "1rem",
                            transition: "transform 0.3s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <i className="bi bi-people fs-1 me-3" style={{ color: "#6B46C1" }}></i>
                                    <h5 className="fw-bold mb-0" style={{ color: "#6B46C1" }}>
                                        Payroll Taxes
                                    </h5>
                                </div>
                                <p className="text-secondary mb-0" style={{ lineHeight: "1.7" }}>
                                    If you have employees, you're responsible for withholding and remitting federal and state income taxes, Social Security, and Medicare on their behalf.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="card border-0 shadow-sm h-100" style={{
                            background: "linear-gradient(135deg, #edeaff 0%, #fff5fb 100%)",
                            borderRadius: "1rem",
                            transition: "transform 0.3s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <i className="bi bi-building fs-1 me-3" style={{ color: "#6B46C1" }}></i>
                                    <h5 className="fw-bold mb-0" style={{ color: "#6B46C1" }}>
                                        Property Taxes
                                    </h5>
                                </div>
                                <p className="text-secondary mb-0" style={{ lineHeight: "1.7" }}>
                                    If your business owns real estate or property, you'll need to pay property taxes to local authorities based on the assessed value.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="card border-0 shadow-sm h-100" style={{
                            background: "linear-gradient(135deg, #fff5fb 0%, #edeaff 100%)",
                            borderRadius: "1rem",
                            transition: "transform 0.3s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                            <div className="card-body p-4">
                                <div className="d-flex align-items-center mb-3">
                                    <i className="bi bi-file-earmark-text fs-1 me-3" style={{ color: "#6B46C1" }}></i>
                                    <h5 className="fw-bold mb-0" style={{ color: "#6B46C1" }}>
                                        Estimated Taxes
                                    </h5>
                                </div>
                                <p className="text-secondary mb-0" style={{ lineHeight: "1.7" }}>
                                    Most businesses must make quarterly estimated tax payments throughout the year to avoid penalties and interest charges.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Business Tax Forms */}
            <section className="container py-5" data-aos="fade-left">
                <div className="row align-items-center">
                    <div className="col-lg-6 mb-4 mb-lg-0">
                        <img
                            src={services}
                            alt="Business Tax Services"
                            className="rounded-4 shadow-lg"
                            style={{ width: "100%", maxWidth: "500px" }}
                            data-aos="zoom-in"
                        />
                    </div>
                    <div className="col-lg-6">
                        <h2 className="fw-bold mb-4" style={{ 
                            color: "#D53F8C", 
                            fontFamily: "Poppins, sans-serif",
                            fontSize: "2rem"
                        }}>
                            Common Business Tax Forms
                        </h2>
                        <div className="row g-3">
                            <div className="col-12">
                                <div className="card border-0 shadow-sm" style={{
                                    background: "linear-gradient(135deg, #edeaff 0%, #fff5fb 100%)",
                                    borderRadius: "1rem"
                                }}>
                                    <div className="card-body p-4">
                                        <h6 className="fw-bold mb-2" style={{ color: "#6B46C1" }}>
                                            Form 1120 (C-Corporation)
                                        </h6>
                                        <p className="text-secondary mb-0 small">
                                            Used by C-Corporations to report income, gains, losses, deductions, and credits.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="card border-0 shadow-sm" style={{
                                    background: "linear-gradient(135deg, #fff5fb 0%, #edeaff 100%)",
                                    borderRadius: "1rem"
                                }}>
                                    <div className="card-body p-4">
                                        <h6 className="fw-bold mb-2" style={{ color: "#6B46C1" }}>
                                            Form 1120S (S-Corporation)
                                        </h6>
                                        <p className="text-secondary mb-0 small">
                                            Used by S-Corporations to report income, deductions, and credits that pass through to shareholders.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="card border-0 shadow-sm" style={{
                                    background: "linear-gradient(135deg, #edeaff 0%, #fff5fb 100%)",
                                    borderRadius: "1rem"
                                }}>
                                    <div className="card-body p-4">
                                        <h6 className="fw-bold mb-2" style={{ color: "#6B46C1" }}>
                                            Form 1065 (Partnership)
                                        </h6>
                                        <p className="text-secondary mb-0 small">
                                            Used by partnerships and multi-member LLCs to report income, deductions, and credits.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </section>

            {/* Business Tax Services */}
            <section className="container py-5" data-aos="fade-up">
                <div className="text-center mb-5">
                    <h2 className="fw-bold mb-3" style={{ 
                        color: "#6B46C1", 
                        fontFamily: "Poppins, sans-serif",
                        fontSize: "2rem"
                    }}>
                        Our Business Tax Services
                    </h2>
                </div>
                <div className="row g-4">
                    <div className="col-md-6 col-lg-4">
                        <div className="card border-0 shadow-sm h-100" style={{
                            background: "linear-gradient(135deg, #edeaff 0%, #fff5fb 100%)",
                            borderRadius: "1rem",
                            transition: "transform 0.3s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                            <div className="card-body p-4 text-center">
                                <i className="bi bi-file-earmark-check fs-1 mb-3" style={{ color: "#6B46C1" }}></i>
                                <h5 className="fw-bold mb-3" style={{ color: "#6B46C1" }}>
                                    Tax Preparation
                                </h5>
                                <p className="text-secondary mb-0">
                                    Accurate preparation and filing of all business tax returns, ensuring compliance and maximizing deductions.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="card border-0 shadow-sm h-100" style={{
                            background: "linear-gradient(135deg, #fff5fb 0%, #edeaff 100%)",
                            borderRadius: "1rem",
                            transition: "transform 0.3s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                            <div className="card-body p-4 text-center">
                                <i className="bi bi-calendar-check fs-1 mb-3" style={{ color: "#6B46C1" }}></i>
                                <h5 className="fw-bold mb-3" style={{ color: "#6B46C1" }}>
                                    Quarterly Tax Planning
                                </h5>
                                <p className="text-secondary mb-0">
                                    Strategic planning for quarterly estimated tax payments to avoid penalties and manage cash flow.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="card border-0 shadow-sm h-100" style={{
                            background: "linear-gradient(135deg, #edeaff 0%, #fff5fb 100%)",
                            borderRadius: "1rem",
                            transition: "transform 0.3s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                            <div className="card-body p-4 text-center">
                                <i className="bi bi-shield-check fs-1 mb-3" style={{ color: "#6B46C1" }}></i>
                                <h5 className="fw-bold mb-3" style={{ color: "#6B46C1" }}>
                                    Audit Representation
                                </h5>
                                <p className="text-secondary mb-0">
                                    Expert representation before the IRS in case of audits, ensuring your business is protected.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="card border-0 shadow-sm h-100" style={{
                            background: "linear-gradient(135deg, #fff5fb 0%, #edeaff 100%)",
                            borderRadius: "1rem",
                            transition: "transform 0.3s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                            <div className="card-body p-4 text-center">
                                <i className="bi bi-graph-up-arrow fs-1 mb-3" style={{ color: "#6B46C1" }}></i>
                                <h5 className="fw-bold mb-3" style={{ color: "#6B46C1" }}>
                                    Tax Strategy Consulting
                                </h5>
                                <p className="text-secondary mb-0">
                                    Strategic tax planning to optimize your business structure and minimize tax liability.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="card border-0 shadow-sm h-100" style={{
                            background: "linear-gradient(135deg, #edeaff 0%, #fff5fb 100%)",
                            borderRadius: "1rem",
                            transition: "transform 0.3s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                            <div className="card-body p-4 text-center">
                                <i className="bi bi-cash-stack fs-1 mb-3" style={{ color: "#6B46C1" }}></i>
                                <h5 className="fw-bold mb-3" style={{ color: "#6B46C1" }}>
                                    Payroll Tax Management
                                </h5>
                                <p className="text-secondary mb-0">
                                    Comprehensive payroll tax services including withholding, reporting, and compliance.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4">
                        <div className="card border-0 shadow-sm h-100" style={{
                            background: "linear-gradient(135deg, #fff5fb 0%, #edeaff 100%)",
                            borderRadius: "1rem",
                            transition: "transform 0.3s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                        onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                            <div className="card-body p-4 text-center">
                                <i className="bi bi-file-earmark-spreadsheet fs-1 mb-3" style={{ color: "#6B46C1" }}></i>
                                <h5 className="fw-bold mb-3" style={{ color: "#6B46C1" }}>
                                    Bookkeeping & Records
                                </h5>
                                <p className="text-secondary mb-0">
                                    Maintain accurate financial records and documentation to support your tax filings.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="py-5 my-5" style={{
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                borderRadius: "2rem"
            }}>
                <div className="container text-center text-white">
                    <h2 className="fw-bold mb-3" style={{ 
                        fontFamily: "Poppins, sans-serif",
                        fontSize: "2rem"
                    }}>
                        Ready to Simplify Your Business Tax Filing?
                    </h2>
                    <p className="lead mb-4 fs-5" style={{ opacity: 0.95, lineHeight: "1.8" }}>
                        Let NEXEN Consulting's expert tax professionals handle your business tax filing needs.<br />
                        Stay compliant, maximize deductions, and focus on growing your business.
                    </p>
                    <Link
                        to="/contact"
                        className="btn btn-light btn-lg rounded-pill fw-bold px-5 py-3"
                        style={{
                            background: "#fff",
                            color: "#6B46C1",
                            border: "none",
                            boxShadow: "0 4px 15px rgba(255, 255, 255, 0.3)",
                            transition: "transform 0.3s ease, box-shadow 0.3s ease"
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "scale(1.05)";
                            e.currentTarget.style.boxShadow = "0 8px 30px rgba(255, 255, 255, 0.5)";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                            e.currentTarget.style.boxShadow = "0 4px 15px rgba(255, 255, 255, 0.3)";
                        }}
                    >
                        Get in Touch
                    </Link>
                </div>
            </section>
        </div>
    );
}

